import NotFoundComponent from "PFComponents/not_found/not_found";
import usePageWrapper from "PFCore/helpers/use_page_wrapper";
import { useBookingConfigCalendars } from "PFCore/hooks/queries/bookings/booking_config/use_booking_config_calendars";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { CalendarsPage } from "./calendars_page";

export const CalendarsController = (): JSX.Element => {
  const { t } = useTranslation(["bookingModule", "translation"]);
  const [page, setPage] = useState(1);
  const [term, setTerm] = useState<string>("");
  const { data, isLoading, error } = useBookingConfigCalendars(page, 10, term);

  const handleTermChange = (term: string) => {
    setTerm(term);
    setPage(1);
  };

  const WrappedCalendars = usePageWrapper(CalendarsPage);

  return (
    <WrappedCalendars
      loading={isLoading}
      errors={error ? [error] : []}
      errorComponent={
        <NotFoundComponent
          message={t("bookingModule:config.calendars.contentCouldntBeLoaded")}
          buttonMessage={t("translation:comeBackLater")}
          buttonUrl="/admin/booking/calendars"
        />
      }
      data={data}
      setPage={setPage}
      term={term}
      setTerm={handleTermChange}
    />
  );
};
